import { Navigate } from 'react-router';
import { UserContext } from '~/app';
import { isOnHlxHost } from '~/config/branding';
import { DefaultRoleRedirect } from './DefaultRoleRedirect';
import { paths } from './routes';

/**
 * Target of the public header's "Go to dashboard" link (`paths.appHome`). [MCV-1723]
 *
 * With no returnTo, DefaultRoleRedirect sends a provider to the MCV vault
 * dashboard (resolveProviderPath in postAuthRedirect.ts), which from an HLX page
 * is a cross-brand hop. An HLX provider's HLX home is Job Opportunities, the same
 * target VaultLayout's brand switch uses (`switchTargetPath`), so handle that one
 * case here. DefaultRoleRedirect still owns the loading spinner, the registration
 * states and every other role.
 */
export const RoleHomeRedirect = () => {
  const isProvider = UserContext.useSelector((state) =>
    state.matches({ $_AUTHENTICATED: '$_AUTHENTICATED_PROVIDER' })
  );

  if (isOnHlxHost(window.location.hostname) && isProvider) {
    return <Navigate to={paths.hlx.jobOpportunities} replace />;
  }

  return <DefaultRoleRedirect />;
};
